<template>
    <b-row class="h-100 align-items-center" >
            <b-col class="mx-auto" sm="6">
                <b-col class="text-center">
                    <div class="sombra">
                        <Alerta
                            :variant="'info'"
                            :texto="'<h5>Para prosseguir faça o procedimento a seguir!</h5>'"
                            :icone="'fa fa-exclamation-circle'"
                        />
                    </div>
                </b-col>
                <vue-recaptcha id="recaptcha" ref="recaptcha"
                    @verify="onVerify" :sitekey="siteKey">
                </vue-recaptcha>
            </b-col>
        </b-row>
</template>

<script>
import Alerta from "@/components/Alertas/Alerta.vue";
import VueRecaptcha from 'vue-recaptcha';

export default {
    data() {
        return {
            siteKey: process.env.VUE_APP_SITE_KEY,
            
        };
    },
    components: {
        Alerta,
        VueRecaptcha,
    },
    methods: {
        onVerify: function (response) {
            if (response) {
                this.$parent.acessoValido = true;
                localStorage['acessoValido' + this.$route.params.idAtendimento] = true;
                this.$parent.iniciarLink();
            }
        },
    },
    created() {
        this.siteKey = process.env.VUE_APP_SITE_KEY;
    },
};
</script>
